import React, { useState ,useEffect } from "react";
import { Form, FormGroup, Label, Input, Button } from "reactstrap";
import { toast } from "react-toastify";
import { createDepartmentApi,getDepartmentsApi, updateDepartmentApi } from "../../../apiServices/department.services";
// import { } from "../../../apiServices/department.services";

const DepartmentForm = ({ isModal, onSuccess, mode, selectedDepartment }) => {
  const [departments, setDepartments] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    code: "",
    parentDepartmentId: "" 
  });
  useEffect(() => {
    const fetchDeps = async () => {
      try {
        const res = await getDepartmentsApi();
        setDepartments(res?.data?.data || []);
      } catch (err) {
        toast.error("Failed to load departments");
      }
    };

    fetchDeps();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name) return toast.error("Name required");

    try {
      if (mode === "edit") {
        await updateDepartmentApi(selectedDepartment._id, formData);
        toast.success("Department updated");
      } else {
        await createDepartmentApi(formData);
        toast.success("Department created");
      }

      onSuccess && onSuccess();

    } catch (err) {
      toast.error(err?.error || "Failed");
    }
  };
useEffect(() => {
  if (mode === "edit" && selectedDepartment) {
    setFormData({
      name: selectedDepartment.name || "",
      code: selectedDepartment.code || "",
      parentDepartmentId:
        selectedDepartment.parentDepartmentId?._id || ""
    });
  }
}, [mode, selectedDepartment]);

  return (
    <Form onSubmit={handleSubmit}>
      <FormGroup>
        <Label>Name</Label>
        <Input
          value={formData.name}
          onChange={(e) =>
            setFormData({ ...formData, name: e.target.value })
          }
        />
      </FormGroup>

      <FormGroup>
        <Label>Code</Label>
        <Input
          value={formData.code}
          onChange={(e) =>
            setFormData({ ...formData, code: e.target.value })
          }
        />
      </FormGroup>
        <FormGroup>
          <Label>Parent Department</Label>
          <Input
            type="select"
            value={formData.parentDepartmentId}
            onChange={(e) =>
              setFormData({
                ...formData,
                parentDepartmentId: e.target.value
              })
            }
          >
            <option value="">None</option>

            {departments.map((d) => (
              <option key={d._id} value={d._id}>
                {d.name}
              </option>
            ))}
          </Input>
        </FormGroup>
      <div className="text-end">
        <Button color="primary">Save</Button>
      </div>
    </Form>
  );
};

export default DepartmentForm;